import { Page } from '@revolut-internal/ui-kit'

import { NotFoundWidget } from 'containers/NotFoundWidget'

export const NotFound = () => (
  <Page.Main>
    <NotFoundWidget description="Page not found." />
  </Page.Main>
)
